import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Signup from 'club/SignupWrapper';
import List from 'club/list/List';
import ForgotPassword from 'club/login/ForgotPassword';
import Login from 'club/login/Login';
import MagicLink from 'club/login/MagicLink';
import Receipt from 'club/receipt/Receipt';
import HostedPayment from 'club/signupHostedPayment/hostedPayment/HostedPayment';
import NotFound from 'common/components/layout/404';
import { getClubSignup } from 'redux/clubSignup/actions';
import { getCustomerWithDefaults } from 'redux/customer/actions';

class ClubApp extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('clubSignupId')) {
      props.getClubSignup();
    }
    if (Cookies.get('customerToken')) {
      props.getCustomerWithDefaults();
    }
  }

  render() {
    return (
      <Switch>
        <Route exact path="/club" component={List} />
        <Route exact path="/club/hosted-payment" component={HostedPayment} />
        <Route exact path="/club/:slug" component={Signup} />
        <Route exact path="/club/:slug/login" component={Login} />
        <Route
          exact
          path="/club/:slug/forgot-password"
          component={ForgotPassword}
        />
        <Route exact path="/club/:slug/magic-link" component={MagicLink} />
        <Route exact={false} path="/club/:slug/signup" component={Signup} />
        <Route exact path="/club/receipt/:id" component={Receipt} />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

export default connect(null, { getCustomerWithDefaults, getClubSignup })(
  ClubApp
);
